import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Welcome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/offers', { replace: true });
  }, [navigate]);

  return null;
};

export { Welcome };
